import { useRef, useState, useEffect } from "react";
import { useSize } from "ahooks";
import KeepScroll from "../../../lib/KeepScroll";
import OfficialRecovery from "../../recovery/Index";
import FreeTrade from "./FreeTrade";
import useUrlState from "@ahooksjs/use-url-state";

export default (props) => {
  const [params, setParams] = useUrlState({}, { navigateMode: "replace" });
  const types = [
    {
      id: 1,
      name: "官方回收",
      component: OfficialRecovery,
    },
    {
      id: 2,
      name: "自由交易",
      component: FreeTrade,
    },
  ];

  const ref = useRef(null);
  const size = useSize(ref);
  const [tab, setTab] = useState(1);
  useEffect(() => {
    setTab(parseInt(params?.tab) || 1);
  }, [params?.tab]);

  return (
    <div
      className="choose-account-content"
      style={{ backgroundColor: "#f5f6f8" }}
    >
      <div
        className="choose-account-tab"
        ref={ref}
        style={{
          justifyContent: "center",
          backgroundColor: "#f5f6f8",
          top: `calc(env(safe-area-inset-top) + ${props.size?.height || 45}px)`,
        }}
      >
        {types.map((item, index) => (
          <div
            key={index}
            style={{ marginRight: item.id === 1 ? "35px" : 0 }}
            className={`item ${item.id === tab ? "active" : ""}`}
            onClick={() => setTab(item.id)}
          >
            {item.name}
          </div>
        ))}
      </div>

      <div className="trade-body" style={{ paddingTop: size?.height || 50 }}>
        {types.map((item, index) => (
          <KeepScroll key={index} active={props.active && item.id === tab} lazy>
            <div
              className={`trade-body-item ${item.id === tab ? "active" : ""}`}
            >
              <item.component active={props.active && item.id === tab} />
            </div>
          </KeepScroll>
        ))}
      </div>
    </div>
  );
};
